import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { toggleClass } from './util';

interface ModalContainerProps {
    visible: boolean;
}

export class ModalContainer extends React.Component<ModalContainerProps> {

    private element?: HTMLElement;

    constructor(props: ModalContainerProps) {
        super(props);
    }

    componentDidMount() {
        this.checkElement();
    }

    componentWillUnmount() {
        if (this.element) {
            this.element.remove();
        }
    }

    checkElement() {
        if (this.element) {
            return;
        }

        const body = document.querySelector('body');
        const element = document.createElement('div');
        element.className = 'cm-modal-container';

        if (body && element) {
            body.appendChild(element);
            this.element = element;
        }
    }

    render() {
        if (!this.element) {
            this.checkElement();
        }

        if (this.element) {
            toggleClass(this.element, 'visible', this.props.visible);
            return ReactDOM.createPortal(this.props.children, this.element);
        }

        return null;
    }
}

interface ModalProps {
    visible: boolean;
    className?: string;
}

export const Modal: React.FC<ModalProps> = ({ visible, className, children }) => {
    let cls = 'cm-modal';

    if (className) {
        cls += ' ' + className;
    }

    return (
        <ModalContainer visible={visible}>
            {visible && <>
                <div className={cls}>
                    {children}
                </div>
            </>}
        </ModalContainer>
    );
}